import { axiosPrivate } from 'shared/api';
import { IActivity } from 'features/cost-analysis/team/activities/types';
import { BaseService } from 'shared/services/BaseService';

class ActivityService extends BaseService<IActivity> {
  constructor() {
    super('staff-management/activities');
  }

  getLayerOptions = async () => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/layer_model_options/`);
    return res.data;
  };

  canDelete = true;
}

export const activityService = new ActivityService();
